import React from 'react';
import { LazyRouteToRightEditor } from '@confluence-classic/confluence-fabric-editor/src/components/RouteToRightEditor/LazyRouteToRightEditor';

import type { RouteMatch } from '@confluence/route/entry-points/Route';
import { getUniquePageLoadId } from '@confluence/unique-page-load-id/entry-points/UniquePageLoadId';

export const EditBlogRoute = ({ params: { contentId, spaceKey } }: RouteMatch) => (
	<LazyRouteToRightEditor contentType="blog" contentId={contentId} spaceKey={spaceKey} />
);

EditBlogRoute.NAVIGATION_PARAMS = ({ params: { contentId, spaceKey } }: RouteMatch) => ({
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: {
			name: 'editPageScreen',
			id: contentId,
			attributes: {
				pageLoadInfo: getUniquePageLoadId(),
			},
		},
		pageState: { contentId, spaceKey, contentType: 'blogpost' },
	},
	MainLayout: false,
});
